class ClearCartBtn extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector("button");
    this.btn?.addEventListener("click", this.clearCart.bind(this));
  }

  clearCart() {
    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(() => {
        window.location.reload();
      })
      .catch((error) => console.error("Error clearing cart:", error));
  }
}

if (!customElements.get("clear-cart-btn")) {
  customElements.define("clear-cart-btn", ClearCartBtn);
}

function clearCart() {
  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(() => {
      window.location.reload();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

if (!customElements.get("customer-toggle")) {
  class CustomerToggle extends HTMLElement {
    constructor() {
      super();
      this.customerToggleApiUrl =
        "https://secondshop-apps-be57801288424ab9b804.o2.myshopify.dev/toggle-customer-tag";
      this.typeOptions = [];
      this.activeOption = undefined;
    }

    connectedCallback() {
      this.initOptions();
    }

    initOptions() {
      this.typeOptions = this.querySelectorAll(".customer-type-toggle__option");
      this.typeOptions.forEach((option) => {
        option.addEventListener("click", () => {
          this.toggleActiveTypeOption(option);
          this.toggleCustomerType(option);
        });
      });

      this.activeOption = this.querySelector(
        ".customer-type-toggle__option.active",
      );
    }

    toggleActiveTypeOption(option) {
      if (this.activeOption) this.activeOption.classList.remove("active");
      option.classList.add("active");
      this.activeOption = option;
    }

    toggleCustomerType(option) {
      const customerId = window.meta.page.customerId;
      if (!customerId) return;

      const formData = new FormData();
      formData.append("customerId", customerId);

      option.classList.add("loading");
      option.querySelector(".loading__spinner")?.classList.remove("hidden");
      fetch(this.customerToggleApiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then(() => {
          clearCart();
          option.classList.remove("loading");
          option.querySelector(".loading__spinner")?.classList.add("hidden");
        })
        .catch((error) => {
          window.location.reload();
          console.error("Error:", error);
        });
    }
  }

  customElements.define("customer-toggle", CustomerToggle);
}

const refreshCartOnLogin = async () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has("just-logged-in")) {
    return;
  }
  try {
    await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    window.location.href = "/";
  } catch (error) {
    console.error("Error:", error);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  refreshCartOnLogin();
});
